module.exports = __webpack_public_path__ + "static/KIN1-a0aff3b9f24a0bb48f75c1917d33965d.png";